/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Type_RefundInputs */

const vi_customer_debt_type_refund = /** @type {(inputs: Customer_Debt_Type_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tiền`)
};

/**

* @param {Customer_Debt_Type_RefundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_type_refund = /** @type {((inputs?: Customer_Debt_Type_RefundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Type_RefundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_type_refund(inputs)
});